import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faSync } from '@fortawesome/free-solid-svg-icons';

const ExchangeRatesTab = () => {
  const { t } = useTranslation();
  const [rates, setRates] = useState({ HUF: '', USD: '', UAH: '' });

  useEffect(() => {
    fetchRates();
  }, []);

  const fetchRates = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/exchange-rates`);
      if (response.data && response.data.rates) {
        setRates(response.data.rates);
      }
    } catch (error) {
      console.error('Error fetching exchange rates:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRates({ ...rates, [name]: value });
  };

  const handleSave = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/exchange-rates`, { rates });
      alert(t('exchangeRatesSaved'));
    } catch (error) {
      console.error('Error saving exchange rates:', error);
      alert(t('failedToSaveExchangeRates'));
    }
  };

  const handleFetchFromApi = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/exchange-rates/fetch`);
      fetchRates();
      alert(t('exchangeRatesFetched'));
    } catch (error) {
      console.error('Error fetching from API:', error);
      alert(t('failedToFetchExchangeRates'));
    }
  };

  return (
    <div className="card bg-white dark:bg-dark-surface p-6 transition-colors">
      <div className="space-y-6">
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label htmlFor="HUF" className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">{t('hufToEur')}</label>
            <input
              type="number"
              name="HUF"
              id="HUF"
              value={rates.HUF}
              onChange={handleInputChange}
              className="w-full p-3 bg-gray-50 dark:bg-dark-bg border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white"
            />
          </div>
          <div>
            <label htmlFor="USD" className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">{t('usdToEur')}</label>
            <input
              type="number"
              name="USD"
              id="USD"
              value={rates.USD}
              onChange={handleInputChange}
              className="w-full p-3 bg-gray-50 dark:bg-dark-bg border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white"
            />
          </div>
          <div>
            <label htmlFor="UAH" className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">{t('uahToEur')}</label>
            <input
              type="number"
              name="UAH"
              id="UAH"
              value={rates.UAH}
              onChange={handleInputChange}
              className="w-full p-3 bg-gray-50 dark:bg-dark-bg border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white"
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <button
            onClick={handleFetchFromApi}
            className="flex items-center gap-2 px-4 py-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition-colors font-medium"
          >
            <FontAwesomeIcon icon={faSync} />
            {t('refreshFromApi')}
          </button>
          <button
            onClick={handleSave}
            className="btn-primary flex items-center gap-2 px-6 py-2 rounded-xl"
          >
            <FontAwesomeIcon icon={faSave} />
            {t('save')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExchangeRatesTab;
